import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Services from "../components/aboutus_services"
import Employees from "../components/aboutus_employee"

const About = () => (
  <Layout>
    <div class="container is-widescreen">
        <Services />
        <Employees />
      </div>
  </Layout>
)

export default About